import { render, staticRenderFns } from "./RNewProductAlertCard.vue?vue&type=template&id=75f6f49c&scoped=true&"
import script from "./RNewProductAlertCard.vue?vue&type=script&lang=js&"
export * from "./RNewProductAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./RNewProductAlertCard.vue?vue&type=style&index=0&id=75f6f49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f6f49c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
